import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a9d81b06&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a9d81b06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d81b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9d81b06')) {
      api.createRecord('a9d81b06', component.options)
    } else {
      api.reload('a9d81b06', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a9d81b06&scoped=true&", function () {
      api.rerender('a9d81b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logo-config/index.vue"
export default component.exports